import React from "react";
import HeaderOne from "../components/HeaderOne";

import FooterAreaOne from "../components/FooterAreaOne";
import Breadcrumb from "../components/Breadcrumb";
import AboutTwo from "../components/AboutTwo";
import CTAAreaOne from "../components/CTAAreaOne";
import TestimonialOne from "../components/TestimonialOne";
import Preloader from "../helper/Preloader";
import useInitialLoad from "../helper/useInitialLoad";
import { Helmet } from "react-helmet-async";


const AboutPage = () => {
  const showPreloader = useInitialLoad(2000);

  return (
    <>
      {/* Preloader */}
      {showPreloader && <Preloader />}
      <Helmet>
        {/* <!-- Basic SEO tags --> */}
        <title>Nosotros | Leal Chapa y Pintura Sevilla</title>
        <meta name="language" content="Spanish" />
        <meta name="author" content="www.lealchapaypintura.com" />
        <meta
          name="description"
          content="Conoce Leal Chapa y Pintura. +15 años de experiencia en Mairena del Aljarafe. Equipo profesional, garantía de por vida. Tu taller de confianza."
        />
        <meta
          name="keywords"
          content="sobre nosotros taller Sevilla, equipo Leal Chapa Pintura, taller confianza Mairena Aljarafe, historia taller PISA"
        />
        <meta name="robots" content="index, follow" />

        {/* <!-- Open Graph tags --> */}
        <meta
          property="og:title"
          content="Nosotros | Leal Chapa y Pintura Sevilla"
        />
        <meta
          property="og:description"
          content="Conoce Leal Chapa y Pintura. +15 años de experiencia en Mairena del Aljarafe. Equipo profesional, garantía de por vida."
        />
        <meta property="og:image" content="https://www.lealchapaypintura.com/favicon.png" />
        <meta property="og:url" content="https://www.lealchapaypintura.com/nosotros" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="es_ES" />

        {/* <!-- Twitter Card tags --> */}
        <meta
          name="twitter:title"
          content="Nosotros | Leal Chapa y Pintura Sevilla"
        />
        <meta
          name="twitter:description"
          content="Conoce Leal Chapa y Pintura. +15 años de experiencia en Mairena del Aljarafe. Equipo profesional, garantía de por vida."
        />
        <meta name="twitter:image" content="https://www.lealchapaypintura.com/favicon.png" />
        <meta name="twitter:card" content="summary_large_image" />

        {/* <!-- Canonical URL --> */}
        <link rel="canonical" href="https://www.lealchapaypintura.com/nosotros" />
      </Helmet>
      {/* Header one */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb title={"Conocenos un poco más"} breadtitle={"Quienes Somos"} />

      {/* About Area */}
      <AboutTwo />

      {/* CTA Area One */}
      <CTAAreaOne />

      {/* Testimonial One */}
      <TestimonialOne />

      {/* Footer Area One */}
      <FooterAreaOne />
    </>
  );
};

export default AboutPage;
